export const APP_NAME = "WORLDATA TEAM";
export const APP_EMAIL = "contact@worldata-team.com";
export const APP_ADDRESS = "11 Rue ampère 75017 paris";
export const APP_PHONE = "+33 1 71 50 10 11";
export const BACK_URL = "https://worldata-team.com/back/public";
export const BACKOFFICE_URL = "https://worldata-team.com/backoffice/";
